<template>
    <div class="flex jc-fs">
        <div v-for="(t, i) in list" class="tab mr-15 fs-18" :class="{ 'active': active == t.value }"
            @click="tabClick(t)">
            {{ t.label }}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: {
        list: {
            type: Array,
            default() {
                return []
            }
        },
        active: {
            type: [String, Number],
            default: ''
        }
    },
    watch: {},
    methods: {
        tabClick(t) {
            this.$emit('update:active', t.value)
            this.$emit('tabChange', t)
        },
    },
}
</script>
<style lang="scss" scoped>
.tab {
    padding: 10px 20px;
    border-radius: 6px;
    color: #676767;
    font-weight: 500;
    border: 1px solid #ddd;
}

.tab.active {
    border: none;
    background-color: var(--color-primary);
    color: #fff;
}
</style>